import { Pipe, PipeTransform } from '@angular/core';
import {
  AIR_POLLUTION,
  allFeatureNames,
  AREA,
  AVERAGE_ANNUAL_SPENDING,
  AVERAGE_HOUSEHOLD_SIZE,
  AVERAGE_TRAVEL_TIME_TO_WORK,
  BACHELORS_DEGREE_OR_HIGHER_FRACTION,
  BEAUTY,
  BIDEN_VS_TRUMP_2020_POPULATION,
  BINGE_DRINKING_RATE,
  BUSINESS_CRIME_RATE,
  CANCER_PREVALENCE,
  COMBINED_HWW_BY_COUNTRY,
  COMBINED_HWW_BY_STATE,
  COMBINED_HWW_CONST,
  COMMUNITY_CRIME_RATE,
  CONVENIENCE_STORES,
  CRIME_RATE,
  CUMULATIVE_TRAFFIC_INTENSITY,
  DIABETES_PREVALENCE,
  DRUGSTORES,
  GENDER_PAY_GAP,
  GINI_INDEX,
  HARRIS_VS_TRUMP_2024_POPULATION,
  HEALTH_INDEX_BY_COUNTRY,
  HEALTH_INDEX_BY_STATE,
  HEALTH_INDEX_CONST,
  HEART_DISEASES_PREVALENCE,
  HOME_OWNERSHIP_RATIO,
  HOME_PRICE_TO_INCOME_RATIO,
  HOUSE_OF_REPRESENTATIVES_ELECTION_RESULTS,
  HOUSEHOLDS,
  LIFE_EXPECTANCY,
  MEDIAN_AGE,
  MEDIAN_GROSS_RENT,
  MEDIAN_GROSS_RENT_TREND,
  MEDIAN_HOUSEHOLD_INCOME_TREND,
  MEDIAN_HOUSING_SALE_COST,
  MEDIAN_HOUSING_SALE_COST_TREND,
  MEDIAN_INCOME,
  MEDIAN_NUMBER_OF_ROOMS,
  MEDIAN_TENURE,
  NUMBER_OF_VEHICLES_AVAILABLE,
  OBESITY_RATE,
  PATIENT_TO_DENTIST_RATIO,
  PATIENT_TO_PHYSICIAN_RATIO,
  PATIENT_TO_THERAPIST_RATIO,
  PEOPLE_PER_MI2,
  POPULATION,
  POPULATION_GROWTH_TREND,
  PRESIDENTIAL_ELECTIONS_RESULTS2020,
  PRESIDENTIAL_ELECTIONS_RESULTS2024,
  PROPERTY_CRIME_RATE,
  RETAIL,
  ROAD_DENSITY,
  SENATE_ELECTION_2022_RESULTS,
  SMOKING_RATE,
  SPECIAL_HEALTH_CARE_NEEDS_INDEX,
  STRUCTURE_BUILT_MEDIAN_YEAR,
  UNEMPLOYMENT_RATIO,
  UNHEALTHY_BEHAVIOUR_INDEX,
  UNINSURED_RATIO,
  VIOLENT_CRIME_RATE,
  WEALTH_INDEX_BY_COUNTRY,
  WEALTH_INDEX_BY_STATE,
  WEALTH_INDEX_CONST,
  WISE_INDEX_BY_COUNTRY,
  WISE_INDEX_BY_STATE,
  WISE_INDEX_CONST,
  WORK_AT_HOME,
} from '../../shared/types/feature-data-type';
import { SubscriptionPlans } from '../../user/user/user.model';

@Pipe({
  name: 'LayerNameFormatPipe',
})
export class LayerNameFormatPipe implements PipeTransform {
  transform(value: string, plan?: SubscriptionPlans | null): string {
    return formatLayerName(value, plan);
  }
}

export function formatLayerName(value: string, plan?: SubscriptionPlans | null): string {
  switch (value) {
    case AREA: return 'Area, sq mi'
    case POPULATION: return 'Population, ppl';
    case PEOPLE_PER_MI2: return 'Population density, ppl per mi²';
    case MEDIAN_INCOME: return 'Median household income, $';
    case BEAUTY: return 'Beauty, %';
    case CONVENIENCE_STORES: return 'C-stores, %';
    case RETAIL: return 'Supermarkets, %';
    case DRUGSTORES: return 'Pharmacy, %';
    case CRIME_RATE: return 'Total crime rate, offenses per 100K ppl';
    case MEDIAN_GROSS_RENT: return 'Median gross rent, $';
    case MEDIAN_HOUSING_SALE_COST: return 'Median home value, $';
    case LIFE_EXPECTANCY: return 'Life expectancy, years';
    case ROAD_DENSITY: return 'Road density, mi/mi²';
    case CUMULATIVE_TRAFFIC_INTENSITY: return 'Traffic intensity, vmt';
    case HOME_PRICE_TO_INCOME_RATIO: return 'Affordability ratio';
    case MEDIAN_AGE: return 'Median age, years';
    case MEDIAN_NUMBER_OF_ROOMS: return 'Median number of rooms';
    case AVERAGE_HOUSEHOLD_SIZE: return 'Household size, ppl';
    case NUMBER_OF_VEHICLES_AVAILABLE: return 'Number of vehicles available';
    case WORK_AT_HOME: return 'Work at home, %';
    case AVERAGE_TRAVEL_TIME_TO_WORK: return 'Commute time, min';
    case AVERAGE_ANNUAL_SPENDING: return 'Consumer spending, $';

    case MEDIAN_HOUSING_SALE_COST_TREND: return 'Annual home value growth, %';
    case MEDIAN_GROSS_RENT_TREND: return 'Annual rent growth, %';
    case POPULATION_GROWTH_TREND: return 'Annual population growth, %';
    case MEDIAN_HOUSEHOLD_INCOME_TREND: return 'Annual income growth, %';
    case UNINSURED_RATIO: return 'Uninsured rate, %';
    case UNEMPLOYMENT_RATIO: return 'Unemployment rate, %';
    case BACHELORS_DEGREE_OR_HIGHER_FRACTION: return 'Bachelor\'s degree or higher, %';

    case SMOKING_RATE: return 'Smoking rate, %';
    case BINGE_DRINKING_RATE: return 'Binge drinking rate, %';
    case OBESITY_RATE: return 'Obesity rate, %';
    case DIABETES_PREVALENCE: return 'Diabetes prevalence, %';
    case CANCER_PREVALENCE: return 'Cancer prevalence, %';
    case HEART_DISEASES_PREVALENCE: return 'Heart disease prevalence, %';
    case AIR_POLLUTION: return 'Air pollution, PM2.5';

    case PATIENT_TO_PHYSICIAN_RATIO: return 'PCP availability, ppl';
    case PATIENT_TO_DENTIST_RATIO: return 'Dentist availability, ppl';
    case PATIENT_TO_THERAPIST_RATIO: return 'Therapist availability, ppl';

    case COMMUNITY_CRIME_RATE: return 'Community crime rate, offenses per 100K ppl';
    case BUSINESS_CRIME_RATE: return 'Business crime rate, offenses per 100K ppl';
    case VIOLENT_CRIME_RATE: return 'Violent crime rate, offenses per 100K ppl'
    case PROPERTY_CRIME_RATE: return 'Property crime rate, offenses per 100K ppl'

    case HOUSEHOLDS: return 'Households';
    case GINI_INDEX: return 'Income Inequality Index (I3)';
    case HOME_OWNERSHIP_RATIO: return 'Homeownership rate, %';
    case GENDER_PAY_GAP: return 'Gender pay gap, %';

    case UNHEALTHY_BEHAVIOUR_INDEX: return 'Unhealthy habits index, %';
    case SPECIAL_HEALTH_CARE_NEEDS_INDEX: return 'Chronic Illness Index, %';

    case PRESIDENTIAL_ELECTIONS_RESULTS2020: return 'Presidential elections 2020 margin'
    case PRESIDENTIAL_ELECTIONS_RESULTS2024: return 'Presidential elections 2024 margin'
    case BIDEN_VS_TRUMP_2020_POPULATION: return 'Population by 2020 presidential election results'
    case HARRIS_VS_TRUMP_2024_POPULATION: return 'Population by 2024 presidential election results'
    case HOUSE_OF_REPRESENTATIVES_ELECTION_RESULTS: return 'House elections margin'
    case SENATE_ELECTION_2022_RESULTS: return 'Senate elections 2022 margin'

    case STRUCTURE_BUILT_MEDIAN_YEAR: return 'Building age'
    case MEDIAN_TENURE: return 'Median tenure, years'

    case COMBINED_HWW_CONST:
    case COMBINED_HWW_BY_COUNTRY:
    case COMBINED_HWW_BY_STATE:
    case HEALTH_INDEX_CONST:
    case HEALTH_INDEX_BY_COUNTRY:
    case HEALTH_INDEX_BY_STATE:
    case WEALTH_INDEX_CONST:
    case WEALTH_INDEX_BY_COUNTRY:
    case WEALTH_INDEX_BY_STATE:
    case WISE_INDEX_CONST:
    case WISE_INDEX_BY_COUNTRY:
    case WISE_INDEX_BY_STATE: return formatHwwForPopup(value, plan);

    case 'Upcoming: Special healthcare needs': return 'Upcoming: Special healthcare needs'
    default:
      if (allFeatureNames.includes(value)) {
        console.warn('layer-name-format.pipe.ts, cant handle case: ', value)
        return transformString(value)
      }
      return '';
  }
}

export function transformString(string: string): string {
  let transformed = string
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/_/g, ' ')
    .toLowerCase()
  // Capitalize the first letter of the first word
  const words = transformed.split(' ');
  if (words.length > 0) {
    words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1);
  }

  return words.join(' ');
}

export function formatHwwForPopup(layer: string, plan?: SubscriptionPlans | null): string {
  const byScale = layer.split('_by_')[1]
  const base = layer.split('_by_')[0]
  let updatedBase = layer.split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
    .split(' By ')[0]

  if (base === WEALTH_INDEX_CONST) {
    updatedBase = 'Income Index';
  } else if (base === WISE_INDEX_CONST) {
    updatedBase = 'Education Index';
  } else if (base === COMBINED_HWW_CONST) {
    updatedBase = 'Area Score';
    if (plan) {
      if (plan === SubscriptionPlans.KNOW_YOUR_COUNTRY) {
        updatedBase = 'Area Score';
      } else  {
        updatedBase = 'Neighborhood Score';
      }
    }
  }

  return `${updatedBase} ${byScale ? 'by ' + byScale.charAt(0).toUpperCase() + byScale.slice(1) : ''}`
}
